import React from 'react';
import { TableCell, Box } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { ContactPersonReportSortInput, EReportsSortDirection } from '__generated__/graphql';

interface SortableContactPersonHeaderProps {
  field: keyof ContactPersonReportSortInput;
  label: string;
  sortFields: ContactPersonReportSortInput[];
  onSort: (field: keyof ContactPersonReportSortInput) => void;
  align?: 'left' | 'center' | 'right';
}

export default function SortableContactPersonHeader({
  field,
  label,
  sortFields,
  onSort,
  align = 'left',
}: SortableContactPersonHeaderProps) {
  const direction = sortFields[0]?.[field] ?? null;

  return (
    <TableCell
      align={align}
      sx={{
        cursor: 'pointer',
        userSelect: 'none',
        '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
      }}
      onClick={() => onSort(field)}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        {label}
        <Box sx={{ display: 'flex', flexDirection: 'column', ml: 0.5 }}>
          <ArrowUpwardIcon
            fontSize="small"
            sx={{ fontSize: 12, opacity: direction === EReportsSortDirection.asc ? 1 : 0.3, color: direction === EReportsSortDirection.asc ? 'primary.main' : 'text.secondary' }}
          />
          <ArrowDownwardIcon
            fontSize="small"
            sx={{ fontSize: 12, marginTop: '-2px', opacity: direction === EReportsSortDirection.desc ? 1 : 0.3, color: direction === EReportsSortDirection.desc ? 'primary.main' : 'text.secondary' }}
          />
        </Box>
      </Box>
    </TableCell>
  );
}
